import { get } from 'lodash'
import { required, minAge } from 'utils/validation'

export default values => {
  let errors = {}

  errors = {
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    birthDate: required(get(values, 'birthDate')) ||
      minAge(get(values, 'birthDate'), 18),
    gender: {
      value: required(get(values, 'gender.value'))
    },
    line1: required(get(values, 'line1')),
    zipCode: required(get(values, 'zipCode')),
    city: required(get(values, 'city')),
    stateOrProvinceOrRegion: required(get(values, 'stateOrProvinceOrRegion')),
    addressCountryId: required(get(values, 'addressCountryId'))
  }

  return errors
}
